"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROVIDER_CODES = exports.MERCURYO_SELL_COUNTRIES = exports.BANXA_SELL_COUNTRIES = exports.MOONPAY_SELL_STATES = exports.MOONPAY_SELL_COUNTRIES = exports.BANXA_STATES = exports.CEX_STATES = exports.SIMPLEX_STATES = exports.MOONPAY_STATES = exports.MERCURYO_SELL_CURRENCIES = exports.BANXA_SELL_CURRENCIES = exports.MOONPAY_SELL_CURRENCIES = exports.DEFAULT_SELL_FIAT = exports.DEFAULT_FIAT = exports.DEFAULT_CRYPTO = exports.FIAT_OPTIONS = exports.COIN_OPTIONS = exports.DEFAULT_CURRENCIES = exports.SIMPLEX_SELL_URL = exports.SIMPLEX_SELL_URL_DEV = exports.SIMPLEX_URL = exports.MOONPAY_URL = exports.CEX_URL = exports.WS_URL = void 0;
const avax_png_1 = __importDefault(require("../../static/coins/avax.png"));
const bch_png_1 = __importDefault(require("../../static/coins/bch.png"));
const btc_png_1 = __importDefault(require("../../static/coins/btc.png"));
const comp_png_1 = __importDefault(require("../../static/coins/comp.png"));
const eth_png_1 = __importDefault(require("../../static/coins/eth.png"));
const bat_png_1 = __importDefault(require("../../static/coins/bat.png"));
const bnb_png_1 = __importDefault(require("../../static/coins/bnb.png"));
const ltc_png_1 = __importDefault(require("../../static/coins/ltc.png"));
const xlm_png_1 = __importDefault(require("../../static/coins/xlm.png"));
const xrp_png_1 = __importDefault(require("../../static/coins/xrp.png"));
const dash_png_1 = __importDefault(require("../../static/coins/dash.png"));
const doge_png_1 = __importDefault(require("../../static/coins/doge.png"));
const dot_png_1 = __importDefault(require("../../static/coins/dot.png"));
const gusd_png_1 = __importDefault(require("../../static/coins/gusd.png"));
const uni_png_1 = __importDefault(require("../../static/coins/uni.png"));
const usdt_png_1 = __importDefault(require("../../static/coins/usdt.png"));
const usdc_png_1 = __importDefault(require("../../static/coins/usdc.png"));
const wbtc_png_1 = __importDefault(require("../../static/coins/wbtc.png"));
const shib_png_1 = __importDefault(require("../../static/coins/shib.png"));
const sushi_png_1 = __importDefault(require("../../static/coins/sushi.png"));
const matic_png_1 = __importDefault(require("../../static/coins/matic.png"));
const verse_png_1 = __importDefault(require("../../static/coins/verse.png"));
exports.WS_URL = "wss://markets-ws.api.bitcoin.com/v1/live-price";
exports.CEX_URL = "https://buy.bitcoin.com/cex/";
exports.MOONPAY_URL = "https://buy.bitcoin.com/moonpay/";
exports.SIMPLEX_URL = "https://buy.bitcoin.com/simplex/";
exports.SIMPLEX_SELL_URL_DEV = "http://simplex-landing-page.trackprogress.online/status-page-iframe/?ref=1ba7ce098d329793aab8adf7608bb5d4";
exports.SIMPLEX_SELL_URL = "https://simplex.com/account/sell/?ref=f8533dc3022147edec32f773c490d0d7";
exports.DEFAULT_CURRENCIES = [
    "VERSE",
    "BCH",
    "BTC",
    "ETH",
    "USD",
    "EUR",
    "GBP",
    "CAD",
    "AUD",
];
exports.COIN_OPTIONS = {
    AVAX: {
        image: avax_png_1.default,
        label: "Avalanche",
        type: "crypto",
        providers: [],
    },
    BAT: {
        image: bat_png_1.default,
        label: "Basic Attention Token",
        type: "crypto",
        providers: [],
    },
    BCH: {
        image: bch_png_1.default,
        label: "Bitcoin Cash",
        type: "crypto",
        providers: [],
    },
    BNB: {
        image: bnb_png_1.default,
        label: "Binance Coin",
        type: "crypto",
        providers: [],
    },
    BTC: {
        image: btc_png_1.default,
        label: "Bitcoin",
        type: "crypto",
        providers: [],
    },
    COMP: {
        image: comp_png_1.default,
        label: "Compound",
        type: "crypto",
        providers: [],
    },
    DASH: {
        image: dash_png_1.default,
        label: "Dash",
        type: "crypto",
        providers: [],
    },
    DOGE: {
        image: doge_png_1.default,
        label: "Dogecoin",
        type: "crypto",
        providers: [],
    },
    DOT: {
        image: dot_png_1.default,
        label: "Polkadot",
        type: "crypto",
        providers: [],
    },
    ETH: {
        image: eth_png_1.default,
        label: "Ethereum",
        type: "crypto",
        providers: [],
    },
    GUSD: {
        image: gusd_png_1.default,
        label: "Gemini Dollar",
        type: "crypto",
        providers: [],
    },
    LTC: {
        image: ltc_png_1.default,
        label: "Litecoin",
        type: "crypto",
        providers: [],
    },
    MATIC: {
        image: matic_png_1.default,
        label: "Polygon",
        type: "crypto",
        providers: [],
    },
    SHIB: {
        image: shib_png_1.default,
        label: "Shiba Inu",
        type: "crypto",
        providers: [],
    },
    SUSHI: {
        image: sushi_png_1.default,
        label: "SushiSwap",
        type: "crypto",
        providers: [],
    },
    UNI: {
        image: uni_png_1.default,
        label: "Uniswap",
        type: "crypto",
        providers: [],
    },
    USDC: {
        image: usdc_png_1.default,
        label: "USD Coin",
        type: "crypto",
        providers: [],
    },
    USDT: {
        image: usdt_png_1.default,
        label: "Tether",
        type: "crypto",
        providers: [],
    },
    WBTC: {
        image: wbtc_png_1.default,
        label: "Wrapped Bitcoin",
        type: "crypto",
        providers: [],
    },
    XLM: {
        image: xlm_png_1.default,
        label: "Stellar",
        type: "crypto",
        providers: [],
    },
    XRP: {
        image: xrp_png_1.default,
        label: "XRP ",
        type: "crypto",
        providers: [],
    },
    VERSE: {
        image: verse_png_1.default,
        label: "Verse",
        type: "crypto",
        providers: [],
        isSellSupported: false,
    },
};
exports.FIAT_OPTIONS = [
    { label: "United Arab Emirates dirham", abbr: "AED", decimals: 2 },
    { label: "Afghan afghani", abbr: "AFN", decimals: 2 },
    { label: "Albanian lek", abbr: "ALL", decimals: 2 },
    { label: "Armenian dram", abbr: "AMD", decimals: 2 },
    { label: "Netherlands Antillean guilder", abbr: "ANG", decimals: 2 },
    { label: "Angolan kwanza", abbr: "AOA", decimals: 2 },
    { label: "Argentine peso", abbr: "ARS", decimals: 2 },
    { label: "Australian dollar", abbr: "AUD", decimals: 2 },
    { label: "Aruban florin", abbr: "AWG", decimals: 2 },
    { label: "Azerbaijani manat", abbr: "AZN", decimals: 2 },
    {
        label: "Bosnia and Herzegovina convertible mark",
        abbr: "BAM",
        decimals: 2,
    },
    { label: "Barbados dollar", abbr: "BBD", decimals: 2 },
    { label: "Bangladeshi taka", abbr: "BDT", decimals: 2 },
    { label: "Bulgarian lev", abbr: "BGN", decimals: 2 },
    { label: "Bahraini dinar", abbr: "BHD", decimals: 3 },
    { label: "Burundian franc", abbr: "BIF", decimals: 0 },
    { label: "Bermudian dollar", abbr: "BMD", decimals: 2 },
    { label: "Brunei dollar", abbr: "BND", decimals: 2 },
    { label: "Boliviano", abbr: "BOB", decimals: 2 },
    { label: "Brazilian real", abbr: "BRL", decimals: 2 },
    { label: "Bahamian dollar", abbr: "BSD", decimals: 2 },
    { label: "Bhutanese ngultrum", abbr: "BTN", decimals: 2 },
    { label: "Botswana pula", abbr: "BWP", decimals: 2 },
    { label: "Belarusian ruble", abbr: "BYN", decimals: 2 },
    { label: "Belize dollar", abbr: "BZD", decimals: 2 },
    { label: "Canadian dollar", abbr: "CAD", decimals: 2 },
    { label: "Congolese franc", abbr: "CDF", decimals: 2 },
    { label: "Swiss franc", abbr: "CHF", decimals: 2 },
    { label: "Unidad de Fomento (funds code)", abbr: "CLF", decimals: 4 },
    { label: "Chilean peso", abbr: "CLP", decimals: 0 },
    { label: "Chinese yuan", abbr: "CNY", decimals: 2 },
    { label: "Colombian peso", abbr: "COP", decimals: 2 },
    { label: "Costa Rican colon", abbr: "CRC", decimals: 2 },
    { label: "Cuban peso", abbr: "CUP", decimals: 2 },
    { label: "Cape Verdean escudo", abbr: "CVE", decimals: 2 },
    { label: "Czech koruna", abbr: "CZK", decimals: 2 },
    { label: "Djiboutian franc", abbr: "DJF", decimals: 0 },
    { label: "Danish krone", abbr: "DKK", decimals: 2 },
    { label: "Dominican peso", abbr: "DOP", decimals: 2 },
    { label: "Algerian dinar", abbr: "DZD", decimals: 2 },
    { label: "Egyptian pound", abbr: "EGP", decimals: 2 },
    { label: "Ethiopian birr", abbr: "ETB", decimals: 2 },
    { label: "Euro", abbr: "EUR", decimals: 2 },
    { label: "Fiji dollar", abbr: "FJD", decimals: 2 },
    { label: "Falkland Islands pound", abbr: "FKP", decimals: 2 },
    { label: "Pound sterling", abbr: "GBP", decimals: 2 },
    { label: "Georgian lari", abbr: "GEL", decimals: 2 },
    { label: "Ghanaian cedi", abbr: "GHS", decimals: 2 },
    { label: "Gibraltar pound", abbr: "GIP", decimals: 2 },
    { label: "Gambian dalasi", abbr: "GMD", decimals: 2 },
    { label: "Guinean franc", abbr: "GNF", decimals: 0 },
    { label: "Guatemalan quetzal", abbr: "GTQ", decimals: 2 },
    { label: "Guyanese dollar", abbr: "GYD", decimals: 2 },
    { label: "Hong Kong dollar", abbr: "HKD", decimals: 2 },
    { label: "Honduran lempira", abbr: "HNL", decimals: 2 },
    { label: "Croatian kuna", abbr: "HRK", decimals: 2 },
    { label: "Haitian gourde", abbr: "HTG", decimals: 2 },
    { label: "Hungarian forint", abbr: "HUF", decimals: 2 },
    { label: "Indonesian rupiah", abbr: "IDR", decimals: 2 },
    { label: "Israeli new shekel", abbr: "ILS", decimals: 2 },
    { label: "Indian rupee", abbr: "INR", decimals: 2 },
    { label: "Iraqi dinar", abbr: "IQD", decimals: 3 },
    { label: "Iranian rial", abbr: "IRR", decimals: 2 },
    { label: "Icelandic króna", abbr: "ISK", decimals: 0 },
    { label: "Jersey pound", abbr: "JEP", decimals: 2 },
    { label: "Jamaican dollar", abbr: "JMD", decimals: 2 },
    { label: "Jordanian dinar", abbr: "JOD", decimals: 3 },
    { label: "Japanese yen", abbr: "JPY", decimals: 0 },
    { label: "Kenyan shilling", abbr: "KES", decimals: 2 },
    { label: "Kyrgyzstani som", abbr: "KGS", decimals: 2 },
    { label: "Cambodian riel", abbr: "KHR", decimals: 2 },
    { label: "Comoro franc", abbr: "KMF", decimals: 0 },
    { label: "North Korean won", abbr: "KPW", decimals: 2 },
    { label: "South Korean won", abbr: "KRW", decimals: 0 },
    { label: "Kuwaiti dinar", abbr: "KWD", decimals: 3 },
    { label: "Cayman Islands dollar", abbr: "KYD", decimals: 2 },
    { label: "Kazakhstani tenge", abbr: "KZT", decimals: 2 },
    { label: "Lao kip", abbr: "LAK", decimals: 2 },
    { label: "Lebanese pound", abbr: "LBP", decimals: 2 },
    { label: "Sri Lankan rupee", abbr: "LKR", decimals: 2 },
    { label: "Liberian dollar", abbr: "LRD", decimals: 2 },
    { label: "Lesotho loti", abbr: "LSL", decimals: 2 },
    { label: "Libyan dinar", abbr: "LYD", decimals: 2 },
    { label: "Moroccan dirham", abbr: "MAD", decimals: 2 },
    { label: "Moldovan leu", abbr: "MDL", decimals: 2 },
    { label: "Malagasy ariary", abbr: "MGA", decimals: 2 },
    { label: "Macedonian denar", abbr: "MKD", decimals: 2 },
    { label: "Myanmar kyat", abbr: "MMK", decimals: 2 },
    { label: "Mongolian tögrög", abbr: "MNT", decimals: 2 },
    { label: "Macanese pataca", abbr: "MOP", decimals: 2 },
    { label: "Mauritanian ouguiya", abbr: "MRU", decimals: 2 },
    { label: "Mauritian rupee", abbr: "MUR", decimals: 2 },
    { label: "Maldivian rufiyaa", abbr: "MVR", decimals: 2 },
    { label: "Malawian kwacha", abbr: "MWK", decimals: 2 },
    { label: "Mexican peso", abbr: "MXN", decimals: 2 },
    { label: "Malaysian ringgit", abbr: "MYR", decimals: 2 },
    { label: "Mozambican metical", abbr: "MZN", decimals: 2 },
    { label: "Namibian dollar", abbr: "NAD", decimals: 2 },
    { label: "Nigerian naira", abbr: "NGN", decimals: 2 },
    { label: "Nicaraguan córdoba", abbr: "NIO", decimals: 2 },
    { label: "Norwegian krone", abbr: "NOK", decimals: 2 },
    { label: "Nepalese rupee", abbr: "NPR", decimals: 2 },
    { label: "New Zealand dollar", abbr: "NZD", decimals: 2 },
    { label: "Omani rial", abbr: "OMR", decimals: 3 },
    { label: "Panamanian balboa", abbr: "PAB", decimals: 2 },
    { label: "Peruvian sol", abbr: "PEN", decimals: 2 },
    { label: "Papua New Guinean kina", abbr: "PGK", decimals: 2 },
    { label: "Philippine peso", abbr: "PHP", decimals: 2 },
    { label: "Pakistani rupee", abbr: "PKR", decimals: 2 },
    { label: "Polish złoty", abbr: "PLN", decimals: 2 },
    { label: "Paraguayan guaraní", abbr: "PYG", decimals: 0 },
    { label: "Qatari riyal", abbr: "QAR", decimals: 2 },
    { label: "Romanian leu", abbr: "RON", decimals: 2 },
    { label: "Serbian dinar", abbr: "RSD", decimals: 2 },
    { label: "Russian ruble", abbr: "RUB", decimals: 2 },
    { label: "Rwandan franc", abbr: "RWF", decimals: 2 },
    { label: "Saudi riyal", abbr: "SAR", decimals: 2 },
    { label: "Solomon Islands dollar", abbr: "SBD", decimals: 2 },
    { label: "Seychelles rupee", abbr: "SCR", decimals: 2 },
    { label: "Sudanese pound", abbr: "SDG", decimals: 2 },
    { label: "Swedish krona", abbr: "SEK", decimals: 2 },
    { label: "Singapore dollar", abbr: "SGD", decimals: 2 },
    { label: "Saint Helena pound", abbr: "SHP", decimals: 2 },
    { label: "Sierra Leonean leone", abbr: "SLL", decimals: 2 },
    { label: "Somali shilling", abbr: "SOS", decimals: 2 },
    { label: "Surinamese dollar", abbr: "SRD", decimals: 2 },
    { label: "São Tomé and Príncipe dobra", abbr: "STN", decimals: 2 },
    { label: "Salvadoran colón", abbr: "SVC", decimals: 2 },
    { label: "Syrian pound", abbr: "SYP", decimals: 2 },
    { label: "Swazi lilangeni", abbr: "SZL", decimals: 2 },
    { label: "Thai baht", abbr: "THB", decimals: 2 },
    { label: "Tajikistani somoni", abbr: "TJS", decimals: 2 },
    { label: "Turkmenistan manat", abbr: "TMT", decimals: 2 },
    { label: "Tunisian dinar", abbr: "TND", decimals: 3 },
    { label: "Tongan paʻanga", abbr: "TOP", decimals: 2 },
    { label: "Turkish lira", abbr: "TRY", decimals: 2 },
    { label: "Trinidad and Tobago dollar", abbr: "TTD", decimals: 2 },
    { label: "New Taiwan dollar", abbr: "TWD", decimals: 2 },
    { label: "Tanzanian shilling", abbr: "TZS", decimals: 2 },
    { label: "Ukrainian hryvnia", abbr: "UAH", decimals: 2 },
    { label: "Ugandan shilling", abbr: "UGX", decimals: 0 },
    { label: "United States dollar", abbr: "USD", decimals: 2 },
    { label: "Uruguayan peso", abbr: "UYU", decimals: 2 },
    { label: "Uzbekistan som", abbr: "UZS", decimals: 2 },
    { label: "Venezuelan bolívar fuerte", abbr: "VEF", decimals: 2 },
    { label: "Venezuelan bolívar soberano", abbr: "VES", decimals: 2 },
    { label: "Vietnamese đồng", abbr: "VND", decimals: 0 },
    { label: "Vanuatu vatu", abbr: "VUV", decimals: 0 },
    { label: "Samoan tala", abbr: "WST", decimals: 2 },
    { label: "CFA franc BEAC", abbr: "XAF", decimals: 0 },
    { label: "Silver", abbr: "XAG", decimals: 2 },
    { label: "Gold", abbr: "XAU", decimals: 2 },
    { label: "East Caribbean dollar", abbr: "XCD", decimals: 2 },
    { label: "CFA franc BCEAO", abbr: "XOF", decimals: 0 },
    { label: "CFP franc", abbr: "XPF", decimals: 0 },
    { label: "Yemeni rial", abbr: "YER", decimals: 2 },
    { label: "South African rand", abbr: "ZAR", decimals: 2 },
    { label: "Zambian kwacha", abbr: "ZMW", decimals: 2 },
    { label: "Zimbabwean dollar", abbr: "ZWL", decimals: 2 },
];
exports.DEFAULT_CRYPTO = {
    code: "BTC",
    label: exports.COIN_OPTIONS.BTC.label,
    image: exports.COIN_OPTIONS.BTC.image,
    type: "crypto",
    providers: [],
};
exports.DEFAULT_FIAT = {
    code: "USD",
    label: "United States Dollar",
    image: "",
    type: "fiat",
    providers: [],
};
exports.DEFAULT_SELL_FIAT = {
    code: "EUR",
    label: "Euro",
    image: "",
    type: "fiat",
    providers: [],
};
exports.MOONPAY_SELL_CURRENCIES = ["EUR", "GBP", "USD"];
exports.BANXA_SELL_CURRENCIES = ["AUD"];
exports.MERCURYO_SELL_CURRENCIES = [
    "EUR",
    "RUB",
    "USD",
];
exports.MOONPAY_STATES = [
    "AK",
    "AL",
    "AR",
    "AZ",
    "CA",
    "CO",
    "CT",
    "DE",
    "FL",
    "GA",
    "IA",
    "ID",
    "IL",
    "IN",
    "KS",
    "KY",
    "MA",
    "MD",
    "ME",
    "MI",
    "MN",
    "MO",
    "MS",
    "MT",
    "NB",
    "NC",
    "ND",
    "NH",
    "NJ",
    "NM",
    "NV",
    "OH",
    "OK",
    "OR",
    "PA",
    "SC",
    "SD",
    "TN",
    "UT",
    "VA",
    "VT",
    "WA",
    "WI",
    "WV",
    "WY",
];
exports.SIMPLEX_STATES = ["LA", "NY", "TX", "VI"];
exports.CEX_STATES = ["HI"];
exports.BANXA_STATES = ["DC"];
// countries with sell providers
exports.MOONPAY_SELL_COUNTRIES = [
    "AT",
    "BE",
    "CH",
    "DE",
    "DK",
    "EE",
    "ES",
    "FI",
    "FR",
    "GB",
    "GR",
    "HU",
    "IE",
    "IT",
    "LI",
    "LT",
    "LV",
    "NL",
    "NO",
    "PT",
    "SE",
    "VA",
];
exports.MOONPAY_SELL_STATES = [
    "AK",
    "AL",
    "AR",
    "AZ",
    "CA",
    "CO",
    "CT",
    "DC",
    "DE",
    "FL",
    "GA",
    "HI",
    "IA",
    "ID",
    "IL",
    "IN",
    "KS",
    "KY",
    "LA",
    "MA",
    "MD",
    "ME",
    "MI",
    "MN",
    "MO",
    "MS",
    "MT",
    "NB",
    "NC",
    "ND",
    "NH",
    "NJ",
    "NM",
    "NV",
    "NY",
    "OH",
    "OK",
    "OR",
    "PA",
    "PR",
    "RI",
    "SC",
    "SD",
    "TN",
    "TX",
    "UT",
    "VA",
    "VI",
    "VT",
    "WA",
    "WI",
    "WV",
    "WY",
];
exports.BANXA_SELL_COUNTRIES = ["AU"];
exports.MERCURYO_SELL_COUNTRIES = [
    "AD",
    "AE",
    "AG",
    "AI",
    "AL",
    "AM",
    "AR",
    "AW",
    "AZ",
    "BA",
    "BF",
    "BG",
    "BH",
    "BJ",
    "BL",
    "BM",
    "BN",
    "BQ",
    "BR",
    "BS",
    "BT",
    "BV",
    "BW",
    "BY",
    "BZ",
    "CA",
    "CI",
    "CM",
    "CV",
    "CW",
    "CY",
    "CZ",
    "DJ",
    "DM",
    "DO",
    "EG",
    "EH",
    "ER",
    "ET",
    "FK",
    "FO",
    "GA",
    "GD",
    "GE",
    "GG",
    "GH",
    "GI",
    "GL",
    "GM",
    "GN",
    "GP",
    "GQ",
    "GS",
    "GY",
    "HK",
    "HR",
    "ID",
    "IL",
    "IM",
    "IN",
    "IO",
    "JE",
    "JM",
    "JO",
    "JP",
    "KE",
    "KM",
    "KN",
    "KP",
    "KW",
    "KY",
    "KZ",
    "LA",
    "LC",
    "LK",
    "LS",
    "LU",
    "MC",
    "MD",
    "ME",
    "MF",
    "MG",
    "MK",
    "MN",
    "MO",
    "MQ",
    "MR",
    "MS",
    "MT",
    "MU",
    "MV",
    "MW",
    "MX",
    "MY",
    "MZ",
    "NA",
    "NE",
    "NG",
    "OM",
    "PH",
    "PL",
    "PM",
    "PR",
    "PY",
    "QA",
    "RE",
    "RO",
    "RS",
    "RU",
    "RW",
    "SC",
    "SG",
    "SH",
    "SI",
    "SJ",
    "SK",
    "SM",
    "SN",
    "SR",
    "ST",
    "SV",
    "SX",
    "SZ",
    "TC",
    "TD",
    "TG",
    "TH",
    "TJ",
    "TL",
    "TM",
    "TR",
    "TT",
    "TW",
    "TZ",
    "UA",
    "UG",
    "UY",
    "UZ",
    "VC",
    "YT",
    "ZA",
    "ZM",
];
exports.PROVIDER_CODES = {
    moonpay: {
        AVAX: "avax_cchain",
        MATIC: "matic_polygon",
    },
    simplex: {
        AVAX: "AVAX-C",
    },
    mercuryo: {},
    banxa: {},
    ramp: {
        MATIC: "MATIC_MATIC",
    },
    cex: {},
};
//# sourceMappingURL=constants.js.map